import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './Routes.module.scss';
import { Filters } from "./Filters/Filters";
import { routesSlice } from "@common/redux/slices/entities.slice";
import { RoutesGrid } from "./RoutesGrid/RoutesGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { regionContent } from "@kursk/content/regionContent";
import { picksSlice } from "@common/redux/slices/picks";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Routes = () => {
  const { total, meta, filters } = useSelectSlice(routesSlice);
  const { listEvents, listOverviews } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);

  return (
    <Layout page="routes">
      <SeoMetaTitles
        page="routes"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, regionContent.entitiesNames.routes.plural)}
      />
      <HeroBlock banners={bannersInCatalogs} page="routes"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            tags={meta.tags}
            selectedTags={selectedTags}
            title={regionContent.entitiesNames.routes.plural}
            dashTitle={`Найдено ${regionContent.entitiesNames.routes.pluralGenitive}`}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters/>
        </div>
        <div className={styles.items}>
          <RoutesGrid/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType='events'
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
